import { render, staticRenderFns } from "./MdrpList.vue?vue&type=template&id=0bd315d9&scoped=true&"
import script from "./MdrpList.vue?vue&type=script&lang=js&"
export * from "./MdrpList.vue?vue&type=script&lang=js&"
import style0 from "./MdrpList.vue?vue&type=style&index=0&id=0bd315d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd315d9",
  null
  
)

export default component.exports